import { baseImageExtension } from '../pages/Achievements/AchievementConstants'
import { exchangeMonthAndDayInDate } from '../pages/Recruitment/InterviewStatusReport/InterviewStatusReportHelpers'
import { GetList } from '../types/EmployeeDirectory/EmployeesList/AddNewEmployee/addNewEmployeeType'

export const PDFheaderId = 'PDFheader'
export const PDFfooterId = 'PDFfooter'
export const PDFbodyId = 'PDFbody'
export const PDFignoreElement =
  'PDFignoreElement-uniqueID-kljsadflkjhafd234jkdsfa'

export const getLatestAgreeRecordFetchFlag = 'getLatestAgreeRecordFetch-Flag'

// Constants for the routes
export const reporteesEmpProfileRoute = 'reporteesEmpProfile'
export const employeeProfileRoute = 'employeeProfile'
export const profileRoute = 'profile'
export const viewProjectRoute = 'viewProject'
export const getRetainerPDFRoute = 'getRetainerPDF'
export const addRetainerInvoiceRoute = 'addRetainerInvoice'
export const editRetainerInvoiceRoute = 'editRetainerInvoice'
export const getFixedbidPDFRoute = 'getFixedbidPDF'
export const raiseProformaInvoiceRoute = 'raiseProformaInvoice'
export const InvoicesListRoute = 'InvoicesList'
export const empHandbookRoute = 'EmployeeHandbook'
export const handbooksettingsRoute = 'handbooksettings'
export const showemployeehandbookRoute = 'showemployeehandbook'

export const priceModelList: GetList[] = [
  { id: 1, name: 'Fixed Bid' },
  { id: 2, name: 'Retainer' },
  { id: 3, name: 'T&M' },
  { id: 4, name: 'Support' },
]
export const healthList = [
  // {
  //   label: 'Gray',
  //   name: 'Project not yet started',
  //   backgroundColor: 'opt-bg-gray',
  // },
  { label: 'Green', name: 'Good', backgroundColor: 'opt-bg-green' },
  { label: 'Orange', name: 'Critical', backgroundColor: 'opt-bg-orange' },
  { label: 'Red', name: 'Danger', backgroundColor: 'opt-bg-danger' },
]

export const ticketStatusList = [
  { label: 'All', name: 'All' },
  { label: 'Closed', name: 'Closed' },
  { label: 'Feedback', name: 'Feedback' },
  { label: 'Fixed', name: 'Fixed' },
  { label: 'In Progress', name: 'In Progress' },
  { label: 'New', name: 'New' },
]

export const approvalStatusList = [
  { label: 'All', name: 'All' },
  { label: 'Approved', name: 'Approved' },
  { label: 'Cancelled', name: 'Cancelled' },
  { label: 'Department', name: 'Department Tickets' },
  { label: 'Pending Approval', name: 'Pending Approval' },
  { label: 'Rejected', name: 'Rejected' },
]

export const dateOptionsList = [
  { label: 'Current Month', name: 'Current Month' },
  { label: 'Custom', name: 'Custom' },
  { label: 'Last Month', name: 'Last Month' },
  { label: 'Last Week', name: 'Last Week' },
  { label: 'This Week', name: 'This Week' },
  { label: 'Today', name: 'Today' },
  { label: 'Yesterday', name: 'Yesterday' },
]

export const reviewListStatus = [
  { label: 'Select Status', name: 'Select Status' },
  { label: 'Completed', name: 'Completed' },
  { label: 'Needs Discussion', name: 'Needs Discussion' },
  { label: 'Needs Acknowledgement', name: 'Acknowledgement' },
  { label: 'Review Pending', name: 'Review Pending' },
  { label: 'Not-Submitted', name: 'Not-Submitted' },
]

export const employeeStatus = [
  { label: 'Active', name: 'Active' },
  { label: 'Inactive', name: 'Inactive' },
]

export const reviewRatings = [
  {
    value: 0,
    text: '0',
  },
  {
    value: 1,
    text: '1',
  },
  {
    value: 2,
    text: '2',
  },
  {
    value: 3,
    text: '3',
  },
  {
    value: 4,
    text: '4',
  },
  {
    value: 5,
    text: '5',
  },
  {
    value: 6,
    text: '6',
  },
  {
    value: 7,
    text: '7',
  },
  {
    value: 8,
    text: '8',
  },
  {
    value: 9,
    text: '9',
  },
  {
    value: 10,
    text: '10',
  },
]

export const NAstring = 'N/A'
export const emptyString = ''
export const regexNumberOnly = /\D/g
export const regexFloatNumberOnly = /[^0-9.]/
export const indianDateFormat = 'dd/MM/yyyy'
export const monthYearFormat = 'MM/yyyy'

// returns true if the input is a valid float number with only one decimal point in the string input
export const isValidDecimal = (input: string): boolean => {
  return /^(\d+\.?\d*|\.\d+)$/.test(input)
}

export const returnValidatedDecimal = (
  input: string,
  fallbackValue: string, // This should be the value of a state where you assign the decimal value. This serves as fallback when input is invalid.
): string => {
  return isValidDecimal(input) || input === '' ? input : fallbackValue
}

//returns true if from date is greater the toDate
export const compareFromAndToDate = (
  fromDate: string,
  toDate: string,
): boolean => {
  // date format must be YYYY-MM-DD or mm/dd/yyyy
  const toD = Date.parse(toDate)
  const fromD = Date.parse(fromDate)
  return fromD > toD
}

// returns true if fromDate is greater than toDate
// this function is used only for testing dates with format mm/yyyy
export const compareFromAndToMonth = (
  fromDate: string,
  toDate: string,
): boolean => {
  const [fromMonth, fromYear] = fromDate.split('/')
  const [toMonth, toYear] = toDate.split('/')
  const fromMonthObj = new Date(Number(fromYear), Number(fromMonth) - 1)
  const toMonthObj = new Date(Number(toYear), Number(toMonth) - 1)
  return fromMonthObj.getTime() > toMonthObj.getTime()
}

//returns final image path for any picture
export const getImageFinalUrl = (picturePath: string): string => {
  const url = new URL(picturePath, baseImageExtension)
  return url.href
}

// dateValue here is considered to be of format dd/MM/yyyy
export const getFinalDateObjectForPicker = (dateValue: string): Date => {
  const finalDateString = exchangeMonthAndDayInDate(dateValue)
  const dateObj = new Date(finalDateString)
  dateObj.setHours(0)
  dateObj.setMinutes(0)
  dateObj.setSeconds(0)
  return dateObj
}

// dateVal here is mm/yyyy format only
export const getFinalMonthYearObjectForPicker = (dateVal: string): Date => {
  const [month, year] = dateVal.split('/')
  const dateObj = new Date(+year, +month - 1, 1)
  dateObj.setHours(0)
  dateObj.setMinutes(0)
  dateObj.setSeconds(0)
  return dateObj
}

// the dateString must be of format dd/mm/yyyy as the date object accepts that format
export const getFinalDateSelectedForPicker = (
  dateString: string,
): Date | null => {
  return dateString === '' ? null : getFinalDateObjectForPicker(dateString)
}

// date string must be of foramt mm/yyyy as this function is only for that
export const getFinalMonthYearSelectedForPicker = (
  dateStr: string,
): Date | null => {
  return dateStr === '' ? null : getFinalMonthYearObjectForPicker(dateStr)
}
